/** Códigos DTC (OBD-II) como P0300, U0100: los que trae el reporte del escáner o se capturan. */
const PATRON = /\b[PBCU][0-9A-F]{4}\b/g;

/** Extrae los códigos de un texto (reporte del escáner en TXT o CSV, o lo que escribe el lotero). */
export function extraerDtc(texto: string): string[] {
  return [...new Set(texto.toUpperCase().match(PATRON) ?? [])].slice(0, 20);
}

/** Imagen a base64 (sin el prefijo data:) para la estimación con IA por fotos. */
export async function aBase64(archivo: Blob): Promise<string> {
  const bytes = new Uint8Array(await archivo.arrayBuffer());
  let binario = '';
  for (let i = 0; i < bytes.length; i += 0x8000)
    binario += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  return btoa(binario);
}
